import { LegalPage } from '@startus/ui';
import { termsOfService } from '@startus/content';

export function TermsOfServicePage() {
  return <LegalPage content={termsOfService} />;
}
